export const BASE_URL = "https://techtionary-project.herokuapp.com";

export const API_URL = (slug) => `${BASE_URL}/${slug}`;
